<div class="content">

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-rose card-header-text">
            <div class="card-text">
              <h4 class="card-title">Announce Data Elements</h4>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <h3 class="title text-primary">Announce Meta Infos</h3>
                <div class="form-group">
                  <input [(ngModel)]="announce.title" name="title" required type="text" class="form-control w-75" placeholder="Announce Title">
                  <span class="bmd-help">Add title for your announce ! Chose ant attractive title for your clients</span>
                  <span class="text-danger" id="announce-title-error"></span>
                </div>
                <div class="form-group">
                  <textarea [(ngModel)]="announce.description" name="description" rows="4" class="form-control w-75" placeholder="Announce Description"></textarea>
                  <span class="bmd-help">Describe what you've got in your announce in order to make your offer clear and understandable</span>
                  <span class="text-danger" id="announce-description-error"></span>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Announce Price MAD</label><br><br>
                  <input [(ngModel)]="announce.price" name="price" required type="number" class="form-control w-75" placeholder="Announce Price MAD">
                  <span class="bmd-help">Set a reasonable prices in order to get attention of your clients</span>
                  <span class="text-danger" id="announce-price-error"></span>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Announce Surface m²</label><br><br>
                  <input [(ngModel)]="announce.surface" name="surface" required type="number" class="form-control w-75" placeholder="Announce Surface m²">
                  <span class="bmd-help">Set a reasonable prices in order to get attention of your clients</span>
                  <span class="text-danger" id="announce-surface-error"></span>
                </div>
              </div>
              <div class="col-md-6">
                <h3 class="title text-primary">Announce Type, State And City</h3>
                <div class="row">
                  <div class="col-md-6">
                    <select [(ngModel)]="announce.type" name="type" required class="selectpicker" data-style="btn btn-primary btn-round" title="Type Select">
                      <option *ngFor="let type of types" value="{{type}}">{{type}}</option>
                    </select>
                    <span class="text-danger" id="announce-type-error"></span>
                  </div>
                  <div class="col-md-6">
                    <select [(ngModel)]="announce.status" required class="selectpicker" data-style="btn btn-rose btn-round text-white" title="State Select">
                      <option *ngFor="let state of states" value="{{state}}">{{state}}</option>
                    </select>
                    <span class="text-danger" id="announce-status-error"></span>
                  </div>
                </div>
                <br><br>
                <div class="col-md-4">
                  <select (change)="searchMapCity()" [(ngModel)]="announce.city" required class="selectpicker" data-style="select-with-transition" multiple title="Choose City">
                    <option *ngFor="let city of cities" value="{{city}}">{{city}}</option>
                  </select>
                  <span class="text-danger" id="announce-city-error"></span>
                </div>
                <h3 class="title text-primary">Announce Detail Infos</h3>
                <div class="form-group">
                  <input [(ngModel)]="announce.address" type="text" class="form-control" placeholder="Address">
                  <span class="bmd-help">Add the address of your announces for more precision</span>
                  <span class="text-danger" id="announce-address-error"></span>
                </div>
                <br><br>
                <div class="form-group">
                  <a class="pieces-rooms-infos" href="javascript:void(0)" (click)="onClick('infos')" >
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </a>
                  <input type="number" class="form-control" placeholder="Available pieces" [(ngModel)]="announce.pieces">
                  <span class="bmd-help">Specify the amount of pieces you have</span>
                  <span class="text-danger" id="announce-pieces-error"></span>
                </div>
                <div class="form-group">
                  <a class="pieces-rooms-infos" href="javascript:void(0)" (click)="onClick('infos')" >
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                  </a>
                  <input type="number" class="form-control" placeholder="Number of Chambers">
                  <span class="bmd-help">Specify the amount of chambers you have</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <h4 class="title">Tags</h4>
                <input type="text" value="Amsterdam,Washington,Sydney,Beijing" class="form-control tagsinput" data-role="tagsinput" data-color="info">
              </div>
              <div class="col-md-6">
                <div class="togglebutton">
                  <h3 class="title text-primary">Rented Or Not Rented ?</h3>
                  <label>
                    <input [(ngModel)]="announce.rent" type="checkbox">
                    <span class="toggle"></span>
                    <span class="text-danger" id="announce-rent-error"></span>
                  </label>
                </div>
              </div>
              <!--<div class="col-md-6">
                <h4 class="title">Dropdown & Dropup</h4>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-3">
                    <div class="dropdown">
                      <button class="dropdown-toggle btn btn-primary btn-round btn-block" type="button" id="multiDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Multilevel Dropdown
                      </button>
                      <div class="dropdown-menu" aria-labelledby="multiDropdownMenu">
                        <a class="dropdown-item" href="#">Action</a>
                        <a class="dropdown-item" href="#">Another action</a>
                        <a class="dropdown-item dropdown-toggle" href="#">Submenu</a>
                        <div class="dropdown-menu">
                          <a class="dropdown-item" href="#">Submenu action</a>
                          <a class="dropdown-item" href="#">Submenu action</a>
                          <a class="dropdown-item dropdown-toggle" href="#">Subsubmenu</a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Subsubmenu action 1</a>
                            <a class="dropdown-item" href="#">Subsubmenu action 2</a>
                          </div>
                          <a class="dropdown-item dropdown-toggle" href="#">Second subsubmenu</a>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#">Subsubmenu action 1</a>
                            <a class="dropdown-item" href="#">Subsubmenu action 2</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-3">
                    <div class="dropdown">
                      <button class="dropdown-toggle btn btn-primary btn-round btn-block" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Dropdown
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <h6 class="dropdown-header">Dropdown header</h6>
                        <a class="dropdown-item" href="#">Action</a>
                        <a class="dropdown-item" href="#">Another action</a>
                        <a class="dropdown-item" href="#">Something else here</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-3 mx-auto">
                    <div class="dropup">
                      <button type="button" class="dropdown-toggle btn btn-primary btn-round btn-block" data-toggle="dropdown">
                        Dropup
                      </button>
                      <div class="dropdown-menu">
                        <h6 class="dropdown-header">Dropdown header</h6>
                        <a class="dropdown-item" href="#">Action</a>
                        <a class="dropdown-item" href="#">Another action</a>
                        <a class="dropdown-item" href="#">Something else here</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>-->
            </div>
            <div class="row">
              <div class="col-md-6">
                <h3 class="title text-primary">Add Images for Your announce</h3>
                <app-announce-images></app-announce-images>
              </div>
              <div class="col-md-6">
                <div id="map-mapbox" style="width: 100%; height: 500px"></div>
                <div class="form-group">
                  <input id='pos' type="text" class="form-control" placeholder="Numeric Location">
                  <span class="bmd-help">Add numeric location of your announce</span>
                  <span class="text-danger" id="announce-location-error"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-center p-5">
            <button type="submit" class="btn btn-primary" (click)="addAnnounce();"><i class="fa fa-paper-plane"></i> Valider</button>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
  </div>
  <div class="container-fluid" id="infos">
    <div class="row">
      <div class="col-md-12">
        <div class="card ">
          <div class="card-header card-header-info card-header-icon">
            <div class="card-icon">
            <span class="material-icons">
              bookmark
            </span>
              <span class="add-announce-title">Tipps</span>
            </div>
          </div>
          <div class="card-body ">
            <h4>Quelle difference entre Pièce et chambre ?</h4>
            <div class="row description-zone" id="pieces-infos">
              <div class="col-md-8 pieces-rooms-infos-text">
                <h4 style="font-weight: bold;color: #9c27b0">Pièce</h4>
                <p>
                  Pour un appartement <strong><b>le nombre de pièces est calculé par espace de vie</b></strong>, sauf pour la salle de bain et la cuisine. <strong><b>La salle de bain et la cuisine ne comptent jamais comme des pièces</b></strong>. Ce qui veut dire qu’un appartement peut avoir ce type de pièces :
                </p>
                <ul>
                  <li>Une chambre</li>
                  <li>Un salon</li>
                  <li>Une salle à manger</li>
                  <li>Un bureau</li>
                </ul>
                <p>
                  <strong style="color: #d21339"><b>Exemple :</b></strong> si l’annonce indique appartement 2 pièces ça veut dire qu’il y a forcément une salle de bain et une cuisine mais qui ne sont pas comptées dans le nombre de pièces. Donc, en nombre de pièces tu as :
                </p>
                <ul>
                  <li>un salon</li>
                  <li>une chambre</li>
                </ul>-->
              </div>
              <div class="col-md-4">
                <img src="../../../../assets/pictures/salon.jpg" class="img-fluid rounded" alt="salon">
              </div>
            </div>
            <div class="row description-zone" id="rooms-infos">
              <div class="col-md-8 pieces-rooms-infos-text">
                <h4 style="font-weight: bold;color: #9c27b0">Chambre</h4>
                <p>Pour connaître le nombre de chambres qu’à un appartement tu comptes tout simplement le nombre de chambres à coucher qu’à l’appartement.</p>
                <p style="margin-top: 10px">
                  <strong style="color: #d21339"><b>Exemple :</b></strong> L’annonce indique appartement 3 pièces – 2 chambres. C’est donc un appartement qui a :
                </p>
                <ul>
                  <li>Un salon qui compte comme 1 pièce</li>
                  <li>2 chambres à coucher qui comptent comme 2 pièces et aussi comme 2 chambres</li>
                  <li>Une cuisine qui ne compte ni comme une pièce ni comme une chambre</li>
                  <li>Une salle de bain qui ne compte ni comme une pièce ni comme une chambre.</li>
                </ul>
              </div>
              <div class="col-md-4">
                <img src="../../../../assets/pictures/chambre2.jpg" class="img-fluid rounded" alt="salon">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<!--<br>
<div class="container">
  <div class="row">

    <div class="col-md-12">
      <div class="card ">
        <div class="card-header card-header-success card-header-icon">
          <div class="card-icon">
            <i class="material-icons">library_books</i>
            <span class="add-announce-title">Ajouter une Annonce</span>
          </div>
        </div>
        <div class="card-body ">
          <form (ngSubmit)="form.valid && this.requiredImages.valid && addAnnounce();" #form="ngForm">

            <div class="container">

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating"> Titre de l'annonce <strong style="color: red">*</strong> :</label>
                    <input type="text"
                           class="form-control" id="announce-title"
                           placeholder="titre" [(ngModel)]="announce.title"
                           ngModel
                           name="title"
                           required
                           maxlength="100"
                           #title="ngModel"
                    >
                    <span class="text-danger" *ngIf="!title.valid && title.touched || form.submitted && !title.valid">Le titre est obligatoire !</span>
                    <span class="text-danger" id="announce-title-error"></span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="type" class="bmd-label-floating">Type <strong style="color: red">*</strong> : </label>
                    <div class="control-group" id="type">
                      <label class="control control--radio">Maison
                        <input type="radio" name="radio" value="maison"
                               id="maison"  [(ngModel)]="announce.type"
                               ngModel
                               #type="ngModel"
                               required
                               [checked]="true"
                        />

                        <div class="control__indicator"></div>
                      </label>
                      <label class="control control--radio">Appartement
                        <input type="radio" name="radio" value="appartement" id="appartement" [(ngModel)]="announce.type" required/>
                        <div class="control__indicator"></div>
                      </label>
                      <label class="control control--radio">Surface
                        <input type="radio" name="radio" value="surface" id="surface" [(ngModel)]="announce.type" required />
                        <div class="control__indicator"></div>
                      </label>
                    </div>
                    <span class="text-danger" *ngIf="!type.valid && type.touched || form.submitted && !type.valid">Le type est obligatoire !</span>
                    <span class="text-danger" id="announce-type-error"></span>
                  </div>
                </div>
              </div>




              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="description" class="bmd-label-floating">Description <strong style="color: red">*</strong> : </label>
                    <textarea id="description" cols="30" rows="10" class="form-control"
                              name="description" [(ngModel)]="announce.description"
                              placeholder="Ensoleillé toute la journée ..."
                              ngModel
                              #description="ngModel"
                              required
                              [maxLength]="100000"
                    ></textarea>
                    <span class="text-danger" *ngIf="!description.valid && description.touched || form.submitted && !description.valid">La description est obligatoire !</span>
                    <span class="text-danger" id="announce-description-error"></span>
                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="price" class="bmd-label-floating">Prix <strong style="color: red">*</strong> : </label>
                    <input type="number" class="form-control" id="price"
                           name="price" [(ngModel)]="announce.price"
                           ngModel
                           #price="ngModel"
                           required
                           min="0"
                    >
                    <span class="text-danger" *ngIf="!price.valid && price.touched || form.submitted && !price.valid">Le prix est obligatoire !</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="status" class="bmd-label-floating">Status <strong style="color: red">*</strong> : </label>
                    <input type="number" class="form-control" id="status"
                           name="status" [(ngModel)]="announce.status"
                           ngModel
                           #status="ngModel"
                           required
                    >
                    <span class="text-danger" *ngIf="!status.valid && status.touched || form.submitted && !status.valid">Le status est obligatoire !</span>
                    <span class="text-danger" id="announce-status-error"></span>
                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="address" class="bmd-label-floating">Adresse <strong style="color: red">*</strong> : </label>
                    <input type="text" class="form-control" id="address"
                           name="address" [(ngModel)]="announce.address"
                           ngModel
                           #address="ngModel"
                           required
                    >
                    <span class="text-danger" *ngIf="!address.valid && address.touched || form.submitted && !address.valid">L'adresse est obligatoire !</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="city" class="bmd-label-floating">Ville <strong style="color: red">*</strong> : </label>
                    <br><br><br>
                    <select class="form-control" id="city"
                            name="city" [(ngModel)]="announce.city"
                            ngModel
                            #city="ngModel"
                            required
                    >
                      <option value="" selected>-- Choisissez la ville --</option>
                      <option *ngFor="let city of cities">{{city}}</option>
                    </select>
                    <span class="text-danger" *ngIf="!city.valid && city.touched || form.submitted && !city.valid">La ville est obligatoire !</span>
                    <span class="text-danger" id="announce-city-error"></span>
                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="mapPosition" class="bmd-label-floating">Localisation : </label>
                    <input type="number" class="form-control" id="mapPosition"
                           name="localisation" [(ngModel)]="announce.position_map">
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="rent" class="bmd-label-floating">Vous cherchez à vendre ou louer ? <strong style="color: red">*</strong> : </label>
                    <select name="rent" id="rent" class="form-control rent"
                            [(ngModel)]="announce.rent"
                            ngModel
                            #rent="ngModel"
                            required
                    >
                      <option value="" selected>-- Choisissez ici --</option>
                      <option value="Location">Location</option>
                      <option value="Vente">Vente</option>
                    </select>
                    <span class="text-danger" *ngIf="!rent.valid && rent.touched || form.submitted && !rent.valid"> Précisez une option !</span>
                    <span class="text-danger" id="announce-rent-error"></span>
                  </div>
                </div>
              </div>
              <br><br>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="groundSurface" class="bmd-label-floating">Surface ( en m² ) <strong style="color: red">*</strong> : </label>
                    <input type="number" class="form-control" id="groundSurface"
                           name="groundSurface" [(ngModel)]="announce.surface"
                           ngModel
                           #groundSurface="ngModel"
                           required
                           min="0"
                    >
                    <span class="text-danger" *ngIf="!groundSurface.valid && groundSurface.touched || form.submitted && !groundSurface.valid">La surface est obligatoire !</span>
                    <span class="text-danger" id="announce-surface-error"></span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="pieces" class="bmd-label-floating">
                      <a class="pieces-rooms-infos" href="javascript:void(0)" (click)="onClick('pieces-infos')" >
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                      </a>
                      Nombre de piéces: </label>
                    <input type="number" class="form-control" id="pieces"
                           name="pieces" [(ngModel)]="announce.pieces"

                           min="0"
                    >
                    <span class="text-danger" id="announce-pieces-error"></span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="rooms" class="bmd-label-floating">
                      <a class="pieces-rooms-infos" href="javascript:void(0)" (click)="onClick('rooms-infos')" >
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                      </a>
                      Nombre de chambres <strong style="color: red">*</strong> : </label>
                    <input type="number" class="form-control" id="rooms"
                           name="rooms" [(ngModel)]="announce.rooms"
                           ngModel
                           #rooms="ngModel"
                           required
                           min="0"
                    >
                    <span class="text-danger" *ngIf="!rooms.valid && rooms.touched || form.submitted && !rooms.valid">Le nombre de chambres est obligatoire !</span>
                    <span class="text-danger" id="announce-rooms-error"></span>
                  </div>
                </div>
              </div>

            <br><br>
              <div class="row">
                <div class="col-md-12">
                  <app-announce-images [control]="form"></app-announce-images>
                </div>
              </div>
            </div>

            <div class="d-flex flex-row justify-content-center">
              <button class="btn btn-fill btn-success" type="submit"  (click)="show()"><i class="fa fa-check" aria-hidden="true"></i> Valider</button>
            </div>

          </form>
        </div>
      </div>
    </div>

  </div>
</div>-->





